module.exports = __webpack_public_path__ + "static/media/logo_tickettong.0cb50b3c.png";